"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesProposalPreview = void 0;
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./SalesProposal.css"));
var PreviewCard_1 = require("Onboarding/CensusCollector/ChooseLandingPoint/PreviewCards/PreviewCard");
var Types_1 = require("@CommonFrontendBackend/Onboarding/Types");
var inversify_react_1 = require("inversify-react");
var Utils_1 = require("@CommonFrontendBackend/Onboarding/Utils");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var SalesProposalPreview = function (_a) {
    var _b, _c, _d;
    var onClick = _a.onClick;
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var usableColors = (0, Utils_1.getUsableColorsAgainstBackground)(brandStore.allColors, "#F2F6F7");
    return (react_1.default.createElement(PreviewCard_1.PreviewCard, { heading: "Sales Proposal", explainer: react_1.default.createElement("span", null, "For Joe Bloggs @ ACME Co"), onClick: function () {
            onClick(Types_1.OnboardingTemplateType.SalesProposal);
        }, css: {
            background: styles.background,
            contentContainer: styles.contentContainer,
            logo: styles.logo,
            heading: styles.heading,
            explainer: styles.explainer,
        }, colors: {
            heading: (_b = usableColors[0]) !== null && _b !== void 0 ? _b : DefaultColors_1.DEFAULT_MIDNIGHT.value,
            explainer: (_d = (_c = usableColors[1]) !== null && _c !== void 0 ? _c : usableColors[0]) !== null && _d !== void 0 ? _d : DefaultColors_1.DEFAULT_MIDNIGHT.value,
        } }));
};
exports.SalesProposalPreview = SalesProposalPreview;
